export class ProgressivesContext {
  constructor(public readonly date: Date, properties: { Id:number; Name: string }[]){
    this.properties = properties.map(p => ({...p, selected: true}));
    this.refreshSelectedProperties();
  }
  properties: { Id: number; Name: string, selected: boolean}[]
  private _selectedPropertyIds: number[] = []
  get selectedPropertyIds() { return this._selectedPropertyIds; }

  refreshSelectedProperties(){
    let selectedPropertyIds = this.properties.filter(p => p.selected).map(p => p.Id);
    if(selectedPropertyIds.length === 0) { selectedPropertyIds = [0] }
    this._selectedPropertyIds = selectedPropertyIds;    
  }
}